import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { InputSearchProps } from "./types";
import styles from "./SearchInput.module.scss";

const InputSearch = ({ value, setValue, placeholder }: InputSearchProps) => {
  const [inputValue, setInput] = useState(value);

  useEffect(() => {
    setInput(value);
  }, [value]);

  useEffect(() => {
    if (value === inputValue) {
      return;
    }
    const timeout = setTimeout(() => {
      setValue(inputValue);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue]);

  return (
    <div className={styles.inputSearch}>
      <input
        type="text"
        placeholder={placeholder}
        value={inputValue}
        className="form-control"
        onChange={(e) => {
          setInput(e.target.value);
        }}
      />
      <FaSearch className={styles.searchIcon} />
    </div>
  );
};

export default InputSearch;
